// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlternateMatchEnum } from './AlternateMatchEnum';
import {
    AlternateMatchEnumFromJSON,
    AlternateMatchEnumFromJSONTyped,
    AlternateMatchEnumToJSON,
    AlternateMatchEnumToJSONTyped,
} from './AlternateMatchEnum';
import type { PTViaNotReference } from './PTViaNotReference';
import {
    PTViaNotReferenceFromJSON,
    PTViaNotReferenceFromJSONTyped,
    PTViaNotReferenceToJSON,
    PTViaNotReferenceToJSONTyped,
} from './PTViaNotReference';
import type { RealtimeModeEnum } from './RealtimeModeEnum';
import {
    RealtimeModeEnumFromJSON,
    RealtimeModeEnumFromJSONTyped,
    RealtimeModeEnumToJSON,
    RealtimeModeEnumToJSONTyped,
} from './RealtimeModeEnum';
import type { TransportModeEnum } from './TransportModeEnum';
import {
    TransportModeEnumFromJSON,
    TransportModeEnumFromJSONTyped,
    TransportModeEnumToJSON,
    TransportModeEnumToJSONTyped,
} from './TransportModeEnum';
import type { TripMobilityFilter } from './TripMobilityFilter';
import {
    TripMobilityFilterFromJSON,
    TripMobilityFilterFromJSONTyped,
    TripMobilityFilterToJSON,
    TripMobilityFilterToJSONTyped,
} from './TripMobilityFilter';
import type { OccupancyAverageEnum } from './OccupancyAverageEnum';
import {
    OccupancyAverageEnumFromJSON,
    OccupancyAverageEnumFromJSONTyped,
    OccupancyAverageEnumToJSON,
    OccupancyAverageEnumToJSONTyped,
} from './OccupancyAverageEnum';
import type { PTViaReference } from './PTViaReference';
import {
    PTViaReferenceFromJSON,
    PTViaReferenceFromJSONTyped,
    PTViaReferenceToJSON,
    PTViaReferenceToJSONTyped,
} from './PTViaReference';
import type { PTViaNoChangeAtReference } from './PTViaNoChangeAtReference';
import {
    PTViaNoChangeAtReferenceFromJSON,
    PTViaNoChangeAtReferenceFromJSONTyped,
    PTViaNoChangeAtReferenceToJSON,
    PTViaNoChangeAtReferenceToJSONTyped,
} from './PTViaNoChangeAtReference';
import type { AccessibilityEnum } from './AccessibilityEnum';
import {
    AccessibilityEnumFromJSON,
    AccessibilityEnumFromJSONTyped,
    AccessibilityEnumToJSON,
    AccessibilityEnumToJSONTyped,
} from './AccessibilityEnum';
import type { NoticeAttributeEnum } from './NoticeAttributeEnum';
import {
    NoticeAttributeEnumFromJSON,
    NoticeAttributeEnumFromJSONTyped,
    NoticeAttributeEnumToJSON,
    NoticeAttributeEnumToJSONTyped,
} from './NoticeAttributeEnum';

/**
 * Request parameters (POST body).
 * @export
 * @interface TripsIntervalByOriginAndDestinationRequestBody
 */
export interface TripsIntervalByOriginAndDestinationRequestBody {
    /**
     * Starting point of the trip at origin (departure). See v3 **PlaceReference** as `StopPlace` only in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @type {string}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    origin: string;
    /**
     * Ending point of the trip at destination (arrival). See **PlaceReference** as `StopPlace` only in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @type {string}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    destination: string;
    /**
     * (Local) date at either origin related to `time`, defaults to TODAY.
     * @type {Date}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    date?: Date;
    /**
     * Local time at either origin related to `date`, defaults to TODAY (seconds will be ignored).
     * @type {string}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    time?: string;
    /**
     * 
     * @type {OccupancyAverageEnum}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    occupancyAverage?: OccupancyAverageEnum;
    /**
     * 
     * @type {TripMobilityFilter}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    mobilityFilter?: TripMobilityFilter;
    /**
     * 
     * @type {Array<PTViaReference>}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    vias?: Array<PTViaReference>;
    /**
     * 
     * @type {Array<PTViaNotReference>}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    viasNot?: Array<PTViaNotReference>;
    /**
     * 
     * @type {Array<PTViaNoChangeAtReference>}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    viasNoTransfer?: Array<PTViaNoChangeAtReference>;
    /**
     * 
     * @type {RealtimeModeEnum}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    realtimeMode?: RealtimeModeEnum;
    /**
     * Based on a returned `TripResponse::pagingCursor`, `previous` or `next` connections **reusing the very same search-parameters** can be retrieved by scrolling pagination mechanism, see `Trip::pagingChecksum`).
     * @type {string}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    pagingCursor?: string;
    /**
     * Maximum number of results to be returned, related to parameter `duration` and may reduce or expand `limit` settings.
     * @type {number}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    limit?: number;
    /**
     * Interval duration [min.] (0..1439) to consider. Relates to parameter `limit`, which will limit results within the duration.
     * @type {number}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    duration?: number;
    /**
     * 
     * @type {AccessibilityEnum}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    includeAccessibility?: AccessibilityEnum;
    /**
     * 
     * @type {AlternateMatchEnum}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    includeAlternateMatch?: AlternateMatchEnum;
    /**
     * 
     * @type {Set<NoticeAttributeEnum>}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    includeNoticeAttributes?: Set<NoticeAttributeEnum>;
    /**
     * 
     * @type {Set<TransportModeEnum>}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    includeTransportModes?: Set<TransportModeEnum>;
    /**
     * Create some summary facts about each Trip (useful for UI overviews).<br>This parameter has an impact on performance and/or response volume, set wisely!
     * @type {boolean}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    includeSummary?: boolean;
    /**
     * Whether the `PTRideLeg's` should include intermediate stops (between the passenger's board and alight in `ServiceJourney::stopPoints`).<br>x-extensible-enum:  [ALL,NONE,BOARDING_ALIGHTING] where ALL is BOARDING_ALIGHTING plus virtual stops.
     * @type {string}
     * @memberof TripsIntervalByOriginAndDestinationRequestBody
     */
    includeIntermediateStops?: TripsIntervalByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum;
}


/**
 * @export
 */
export const TripsIntervalByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum = {
    All: 'ALL',
    BoardingAlighting: 'BOARDING_ALIGHTING',
    None: 'NONE'
} as const;
export type TripsIntervalByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum = typeof TripsIntervalByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum[keyof typeof TripsIntervalByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum];


/**
 * Check if a given object implements the TripsIntervalByOriginAndDestinationRequestBody interface.
 */
export function instanceOfTripsIntervalByOriginAndDestinationRequestBody(value: object): value is TripsIntervalByOriginAndDestinationRequestBody {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('destination' in value) || value['destination'] === undefined) return false;
    return true;
}

export function TripsIntervalByOriginAndDestinationRequestBodyFromJSON(json: any): TripsIntervalByOriginAndDestinationRequestBody {
    return TripsIntervalByOriginAndDestinationRequestBodyFromJSONTyped(json, false);
}

export function TripsIntervalByOriginAndDestinationRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripsIntervalByOriginAndDestinationRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': json['origin'],
        'destination': json['destination'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'time': json['time'] == null ? undefined : json['time'],
        'occupancyAverage': json['occupancyAverage'] == null ? undefined : OccupancyAverageEnumFromJSON(json['occupancyAverage']),
        'mobilityFilter': json['mobilityFilter'] == null ? undefined : TripMobilityFilterFromJSON(json['mobilityFilter']),
        'vias': json['vias'] == null ? undefined : ((json['vias'] as Array<any>).map(PTViaReferenceFromJSON)),
        'viasNot': json['viasNot'] == null ? undefined : ((json['viasNot'] as Array<any>).map(PTViaNotReferenceFromJSON)),
        'viasNoTransfer': json['viasNoTransfer'] == null ? undefined : ((json['viasNoTransfer'] as Array<any>).map(PTViaNoChangeAtReferenceFromJSON)),
        'realtimeMode': json['realtimeMode'] == null ? undefined : RealtimeModeEnumFromJSON(json['realtimeMode']),
        'pagingCursor': json['pagingCursor'] == null ? undefined : json['pagingCursor'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'includeAccessibility': json['includeAccessibility'] == null ? undefined : AccessibilityEnumFromJSON(json['includeAccessibility']),
        'includeAlternateMatch': json['includeAlternateMatch'] == null ? undefined : AlternateMatchEnumFromJSON(json['includeAlternateMatch']),
        'includeNoticeAttributes': json['includeNoticeAttributes'] == null ? undefined : (new Set((json['includeNoticeAttributes'] as Array<any>).map(NoticeAttributeEnumFromJSON))),
        'includeTransportModes': json['includeTransportModes'] == null ? undefined : (new Set((json['includeTransportModes'] as Array<any>).map(TransportModeEnumFromJSON))),
        'includeSummary': json['includeSummary'] == null ? undefined : json['includeSummary'],
        'includeIntermediateStops': json['includeIntermediateStops'] == null ? undefined : json['includeIntermediateStops'],
    };
}

  export function TripsIntervalByOriginAndDestinationRequestBodyToJSON(json: any): TripsIntervalByOriginAndDestinationRequestBody {
      return TripsIntervalByOriginAndDestinationRequestBodyToJSONTyped(json, false);
  }

  export function TripsIntervalByOriginAndDestinationRequestBodyToJSONTyped(value?: TripsIntervalByOriginAndDestinationRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'origin': value['origin'],
        'destination': value['destination'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0,10)),
        'time': value['time'],
        'occupancyAverage': OccupancyAverageEnumToJSON(value['occupancyAverage']),
        'mobilityFilter': TripMobilityFilterToJSON(value['mobilityFilter']),
        'vias': value['vias'] == null ? undefined : ((value['vias'] as Array<any>).map(PTViaReferenceToJSON)),
        'viasNot': value['viasNot'] == null ? undefined : ((value['viasNot'] as Array<any>).map(PTViaNotReferenceToJSON)),
        'viasNoTransfer': value['viasNoTransfer'] == null ? undefined : ((value['viasNoTransfer'] as Array<any>).map(PTViaNoChangeAtReferenceToJSON)),
        'realtimeMode': RealtimeModeEnumToJSON(value['realtimeMode']),
        'pagingCursor': value['pagingCursor'],
        'limit': value['limit'],
        'duration': value['duration'],
        'includeAccessibility': AccessibilityEnumToJSON(value['includeAccessibility']),
        'includeAlternateMatch': AlternateMatchEnumToJSON(value['includeAlternateMatch']),
        'includeNoticeAttributes': value['includeNoticeAttributes'] == null ? undefined : (Array.from(value['includeNoticeAttributes'] as Set<any>).map(NoticeAttributeEnumToJSON)),
        'includeTransportModes': value['includeTransportModes'] == null ? undefined : (Array.from(value['includeTransportModes'] as Set<any>).map(TransportModeEnumToJSON)),
        'includeSummary': value['includeSummary'],
        'includeIntermediateStops': value['includeIntermediateStops'],
    };
}

